const comparePassword = (field) => (value, fields) => {
  if (value && value !== fields[field]) {
    return 'Passwords do not match';
  }
  return undefined;
};

export default comparePassword;
